import React, { useMemo } from 'react';
import './TranslationHistory.css';
import HistoryEntry from './HistoryEntry';

function TranslationHistory({
  entries,
  searchQuery,
  onSearchChange,
  onDelete,
  onClearAll,
  totalEntries,
}) {


  return (
    <div className="translation-history">
      <div className="history-header">
        <h2>履歴 ({totalEntries}件)</h2>
      </div>

      {totalEntries > 0 && (
        <>
          <div className="search-and-filter">
            <div className="search-box">
              <input
                type="text"
                placeholder="翻訳を検索..."
                value={searchQuery}
                onChange={(e) => onSearchChange(e.target.value)}
                className="search-input"
              />
              <span className="search-icon">🔍</span>
            </div>
          </div>

          {entries.length > 0 ? (
            <div className="entries-container">
              <div className="entries-table">
                {entries.map(entry => (
                  <HistoryEntry
                    key={entry.id}
                    entry={entry}
                    onDelete={onDelete}
                  />
                ))}
              </div>
            </div>
          ) : (
            <div className="no-results">
              検索条件に合致する翻訳履歴がありません
            </div>
          )}
        </>
      )}

      {totalEntries === 0 && (
        <div className="empty-state">
          <p className="empty-icon">📭</p>
          <p className="empty-text">まだ翻訳履歴がありません</p>
          <p className="empty-hint">左側のフォームでテキストを翻訳してください</p>
        </div>
      )}

      {totalEntries > 0 && (
        <button className="btn-clear-all" onClick={onClearAll}>
          すべて削除
        </button>
      )}
    </div>
  );
}

export default TranslationHistory;
